export function authHeader() {
    // return authorization header with jwt token
    let token = JSON.parse(localStorage.getItem('token'));
    let tokenMerchant = JSON.parse(localStorage.getItem('tokenMerchant'));
    if (token) {
        return { 'Authorization': token, 'secret': 'onemanarmy', 'Content-Type': 'application/json' };
    } else if (tokenMerchant) {
        return { 'Authorization': tokenMerchant, 'secret': 'onemanarmy', 'Content-Type': 'application/json' };
    } else {
        return {};
    }
}